export const helpComponentInfo = {
  superAdmin: {
    role: "SPADM",
    dashboard: {
      path: "/dashboard",
      components: [
        {
          "Dashboard": `Bienvenido al Dashboard. esta pantalla incluye los envíos de todos los Propietarios y subclientes.`,
        },
        { "Envíos mensuales": "Total de envíos en el mes por cliente." },
        {
          "Envíos por medio usado (año)":
            "Total de envíos en el mes por producto.",
        },
        {
          "Envíos por tipo (año)": `Envíos por tipo de envío el cual está ligado al producto, por
                                      ejemplo enviar por SMS.`,
        },
        {
          "Envíos por propietario (mensual)":
            "Total de envíos agrupados por clientes Propietarios",
        },
        {
          "Envíos por producto":
            "Total envíos agrupados por el tipo de envío en los productos.",
        },
      ],
    },
    plan: {
      path: "/planes",
      components: [
        {
          "Planes": `Bienvenido al módulo 'Planes' . Aquí puedes visualizar
                  todos los planes disponibles que ha creado un usuario admin. Esta sección contiene las siguientes
                  funciones:`,
        },
        {
          "Lista de planes":
            "Todos los planes creados en base a dueño y estado.",
        },
        {
          "Ver": `En la columna 'acciones' haga click en el icono "ver" y obtenga información de aprovisionamiento del plan de la fila seleccionada,
                tal como tipo de producto, cantidad entre otros. `,
        },
        {
          "Clientes":
            "En la columna 'acciones' haga click sobre el ícono clientes para ver los subclientes a los que se asigna dicho plan.",
        },
      ],
    },
    sender: {
      path: "/remitentes",
      components: [
        {
          "Remitentes": `Bienvenido a la sección 'Remitentes'. Aquí puedes gestionar la información de los
                        individuos o entidades que envían mensajes o paquetes a través de nuestra plataforma. Las funcionalidades incluyen:`,
        },
        {
          "Nuevo remitente":
            "Haz clic en 'Nuevo' para introducir los datos de un nuevo remitente. tienes la opción de asignarlo a un cliente",
        },
        {
          "Asignacion multiple":
            "Utiliza la opción 'Asignación múltiple' para asignar distintos remitentes a un mismo cliente al mismo tiempo.",
        },
        {
          "Eliminar remitente":
            "Si necesitas eliminar un remitente, puedes hacerlo seleccionando el icono de la papelera.",
        },
        {
          "Editar información del remitente":
            "Selecciona el icono de edición en 'Acciones' para actualizar la información de un remitente existente.",
        },
        {
          "Asignar":
            "Selecciona el icono de asignacion para designar el remitente al cierto cliente",
        },
        {
          "Filtrar y buscar":
            "Utiliza las opciones de filtrado y búsqueda para encontrar rápidamente remitentes específicos segun el cliente.",
        },
      ],
    },
    category: {
      path: "/categorias",
      components: [
        {
          "Categorías": `Bienvenido a la sección 'Categorías', Aquí podrá administrar la gestión de categorías para asignarlas 
                        a los clientes, Cada categoría tendrá un nombre y una descripción asignada. Misma información podrá ser editada..`,
        },
        {
          "Nuevo":
            "Genera un nombre y descripción para una nueva categoría, con esta se puede etiquetar a los clientes",
        },
        {
          "Eliminar y editar":
            "Una vez creada, solo es posible eliminar o editar el nombre y descripción de una categoría.",
        },
      ],
    },
    country: {
      path: "/paises",
      components: [
        {
          "Paises": `Bienvenido al módulo 'Países'. Este espacio está dedicado a la gestión de los países disponibles para
                      realizar envíos:`,
        },
        {
          "Nuevo":
            "Puedes elegir uno de los paises de la lista para agregarlo a tu lista.",
        },
        {
          "Habilitar":
            "Haz click en el icono habilitar/deshabilitar para activar o desactivar un pais de tu lista, su estado cambiará a la opcion elegida.",
        },
        {
          "Editar":
            "Haz click en el icono de editar para asignar la longitud de numero telefónico y el Impuesto a aplicar para todo ese país.",
        },
      ],
    },
    adminCustomers: {
      path: "/clientes/admin",
      components: [
        {
          "Administrar Clientes": `Bienvenido al módulo 'Clientes', concretamente a la sección de administración. aquí se puede visualizar y gestionar
                                     a todos los clientes, tanto Propietarios como subclientes. Para los subclientes, podrán ver el plan, el día de 
                                     corte, los remitentes y el país de destino.`,
        },
        {
          "Inhabilitar":
            "Haz click en icono de dehabilitar, al inhabilitar un propietario se le quitara a acceso a su administrador y a todos los usuarios de los subclientes que este contenga",
        },
        {
          "Crear distinción de costos":
            "Esta acción está disponible para subclientes que no posean distinción de costos (Cuenta EMG).",
        },
      ],
    },

    createNewCustomer: {
      path: "/clientes/admin/agregar",
      components: [
        {
          "Crear nuevo cliente":
            "Esta sección es para crear clientes Propietarios, la cuenta EMG es obligatoria para los Propietarios",
        },
        {
          "Campos":
            "Los campos a asignar a un nuevo cliente son en base a paises y categorías, ademas de datos especificos del cliente",
        },
        {
          "*Nota":
            "Tanto los países como las categorías se deben haber creado previamente para poder completar sus respectivos campos",
        },
      ],
    },
    customerConsuption: {
      path: "/clientes/consumo",
      components: [
        {
          "Resumen de consumo": `En esta sección se puede visualizar información de utilidad en cuanto al control
                                  del consumo de los subclientes de los clientes Propietarios en base a su plan asignado.`,
        },
        {
          "Propietario:": "Cuenta propietaria del subcliente",
        },
        {
          "Estado":
            "Activo/inactivo, determina la validez actual del plan para el subcliente. ",
        },
        {
          "Enviados dentro/fuera":
            "Cantidad de mensajes enviados en base al plan inicial o por fuera de este como un 'extra'",
        },
        {
          "Filtrar:":
            "Es posible filtrar por propietario o realizar una busqueda por palabra clave.",
        },
        {
          "Descargar":
            "Haga click en el boton 'descargar' para bajar un archivo CSV con todos los registros de consumo del propietario seleccionado.",
        },
      ],
    },
    products: {
      path: "/productos",
      components: [
        {
          "Productos:":
            "Bienvenido al módulo 'Productos', aquí es posible gestionar los productos que estarán disponibles en la plataforma",
        },
        {
          "Crear producto":
            "Haga click en el botón 'nuevo' para definir y crear un nuevo producto.",
        },
        {
          "Eliminar":
            "Bajo la columna acciones, haga click en el boton de la papelera para eliminar un producto creado",
        },
        {
          "Editar":
            "Bajo la columna acciones, haga click en el boton de edicion para cambiar el nombre, costo y MTR a un producto previamente creado.",
        },
        { "*Nota": "MTR es un identificador único para cada producto" },
      ],
    },
    newProduct: {
      path: "/productos/agregar",
      components: [
        {
          "Agregar producto":
            "En esta sección es posible crear un nuevo producto para asignar posteriormente a un plan",
        },
        {
          "Campos":
            "Se deben asignar los datos destinados a cada producto como ser nombre, MTR y tipo de envío.",
        },
      ],
    },
    securityBlackList: {
      path: "/seguridad/lista-negra",
      components: [
        {
          "Lista negra":
            "Bienvenido a la sección de lista negra, en este módulo es posible visualizar los números de teléfono enviados a la 'blacklist' los cuales no podrán recibir ni enviar tráfico",
        },
        {
          "": "aquí se muestran los números bloqueados por los subclientes de todos los Propietarios",
        },
      ],
    },

    securityBlackOut: {
      path: "/seguridad/black-out",
      components: [
        {
          "Fuera de linea": `En esta parte del sistema es posible crear horarios en los que un subcliente 
                           no podrá enviar ni recibir tráfico durante las horas y fechas establecidas por los subclientes de todos los Propietarios.`,
        },
      ],
    },
    adminUsers: {
      path: "/admin/usuarios",
      components: [
        {
          "Administrar usuarios": `En este módulo es posible visualizar, crear y asignar usuarios a los clientes, el detalle se
                                  muestra en la lista en pantalla, aquí podemos ver al cliente propietario de los usuarios.`,
        },
        {
          "Editar":
            "Haz click en el ícono de edición y será posible editar la información de un usuario existente.",
        },
        {
          "Deshabilitar":
            "El usuario super admin tiene la potestad de eliminar cualquier usuario desde este botón en la columna 'acciones'",
        },
        {
          "Copiar API key":
            "Esta acción es posible para los clientes remitentes al hacer click sobre el boton 'copiar' bajo la columna 'aaciones'",
        },
      ],
    },
    adminUsersNew: {
      path: "/admin/usuarios/agregar",
      components: [
        {
          "Agregar usuario":
            "En esta sección es posible crear un nuevo usuario que se asigna a un cliente, el usuario super admin es capaz de crear cualquier tipo de usuario disponible en el sistema.",
        },
        {
          "Rol": "aquí es posible asignar un rol al usuario que se esta creando, esto despliega la sección de control de acceso para un rol 'admin' y para el rol 'remitente', ademas para este último se muestra también la posibilidad de envío por api o por web",
        },
        { "Cliente": "Asignar un cliente al usuario" },
        {
          "*Nota":
            "Debe existir previamente el 'cliente' antes de asignarlo al 'usuario' que se esta creando y que será quien accede al sistema",
        },
      ],
    },
    adminAgenda: {
      path: "/admin/agenda-cambios",
      components: [
        {
          "Agenda de cambios": `Bienvenido al componente 'Agenda de cambios',aquí podrá gestionar los cambios de planes y fechas de cortes pendientes de aplicar en las
                              fechas de corte, permitiendo verlo desde una perspectiva de calendario`,
        },
      ],
    },
    adminConfiguration: {
      path: "/admin/configuracion",
      components: [
        {
          "Configuración": `Este módulo te permite configurar los temas y estilos de la aplicación para que se adapten a la identidad visual de tu empresa. Para ello, 
                          puedes cambiar los colores, el logotipo y otros elementos de la interfaz. `,
        },
        {
          "General":
            "En la sección general se puede elegir el cliente a quien se aplicarán los cambios en la aplicación.",
        },
        {
          "Logo": "En la sección de logo, haga click en seleccionar para subir la imagen de su corporación, solo admite el formato PNG.",
        },
        {
          "Imagen de carga":
            "En esta sección se puede definir la imagen que se mostrará en pantalla de carga mientras navega por la app",
        },
        {
          "Paleta de colores":
            "En la parte inferior de los componentes anteriores encontrará la paleta de colores personalizable para identificarse con los colores de su marca.",
        },
      ],
    },
    phonebook: {
      path: "/directorio-telefonico",
      components: [
        {
          "Directorio telefónico": `Bienvenido al módulo de 'directorio telefónico', aquí se realiza la visualización y gestión
                                  de grupos de contactos creados por los subclientes de todos los Propietarios para realizar envíos`,
        },
      ],
    },
    inbox: {
      path: "/inbox",
      components: [
        {
          "Bandeja de entrada": `Bienvenido a la bandeja de entrada, aquí es posible visualizar y gestionar mensajes recibidos con
                                filtro por cliente, este módulo esta en proceso de construcción`,
        },
      ],
    },
    whatsappFastDelivery: {
      path: "/whatsapp/rapido",
      components: [
        {
          Whatsapp: `Bienvenido al módulo de whatsapp, aquí es posible la visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    whatsappFileAttachment: {
      path: "/whatsapp/archivo",
      components: [
        {
          Whatsapp: `Visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    whatsappChat: {
      path: "/whatsapp/chat",
      components: [
        {
          Whatsapp: `Visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    reportsSentSms: {
      path: "/reportes/sms-enviados",
      components: [
        {
          "Mensajes enviados": `Bienvenido al módulo de mensajes enviados, esta vista permite visualizar un listado de los envíos realizados, 
                              este módulo también contiene filtros de fecha los cuales sirven para acotar los envíos por un rango de fechas`,
        },
        {
          "Acciones":
            "En este apartado haga click sobre el icono de 'ver' para obtener el reporte de mensajes enviados por el cliente",
        },
      ],
    },
    reportsProcessedFiles: {
      path: "/reportes/archivos-procesados",
      components: [
        {
          "Archivos procesados": `Bienvenido al módulo de 'archivos procesados' Esta vista te permite ver un listado de todos los archivos que han sido
                                procesados por la aplicación. Para acotar los resultados, puedes utilizar los filtros de fecha y cliente.`,
        },
        {
          "Acciones":
            "Este apartado muestra las acciones que puede realizar sobre estos reportes.",
        },
        {
          "Ver": "Haz click en los íconos ver para obtener información mas detallada sobre el archivo procesado.",
        },
        {
          "Descargar":
            "Haz click en el ícono descargar para obtener el archivo procesado en formato CSV.",
        },
      ],
    },
    reportsByRecipient: {
      path: "/reportes/destino",
      components: [
        {
          "Reporte por destinatario": `Bienvenido al módulo de 'reporte por destinatario' Esta vista te permite ver un listado de todos los envíos realizados
                                    tanto por destinatario como por fecha.`,
        },
        {
          "¿Como buscar?":
            "En la columna destinatario se debe introducir el número de teléfono con el prefijo de este para obtener el reporte de envíos  por destinatario de todos los subclientes de todos los Propietarios.",
        },
      ],
    },
    reportsProgrammedFiles: {
      path: "/reportes/archivos-programados",
      components: [
        {
          "Archivos Programados": `Bienvenido al módulo de 'archivos programados' Esta vista te permite la visualización de los envíos programados de todos los subclientes de todos los Propietarios.
                                 para acotar los resultados, puedes utilizar los filtros de fecha.`,
        },
      ],
    },

    reportsTransactions: {
      path: "/reportes/transacciones",
      components: [
        {
          "Transacciones": `Bienvenido al módulo de 'transacciones', en este apartado es posible la visualización de las transacciones de
                          envíos realizadas de todos los subclientes de todos los Propietarios. A partir de estas transacciones se realizan las facturas en el día de corte`,
        },
        {
          "Parametros de busqueda":
            "Los resultados se filtran por fecha de inicio y final ademas del cliente propietario.",
        },
      ],
    },
    billing: {
      path: "/facturacion/reporte",
      components: [
        {
          "Facturación": `Bienvenido al módulo de facturación, en este apartado se puede realizar la visualización de las facturas generadas en los ciclos de corte.`,
        },
        {
          "Contenido":
            "Cada registro del reporte contiene la información de una factura, incluyendo la fecha de corte, el nombre del propietario, el nombre del cliente, el plan, el subtotal, el ISV, el monto y la cantidad total de mensajes.",
        },
        {
          "Acciones":
            "Haga click en el ícono de 'ver mas' para mostrar el registro a detalle",
        },
      ],
    },
    billingReport: {
      path: "/facturacion/reporte",
      components: [
        {
          "Detalle de facturación":
            "Bienvenido al apartado de facturación, aquí es posible la visualización de las facturas generadas en los ciclos de corte por cada subcliente y propietario.",
        },
        {
          "Acciones":
            "Haga click en el botón 'ver' para ver el detalle de la factura seleccionada",
        },
      ],
    },
    billingReportDetails: {
      path: "/facturacion/reporte/detalles",
      components: [
        {
          "Detalle de facturación":
            "Bienvenido al apartado de detalle de facturación, aquí es posible la generación de recibo, visualizar aprovisionamiento de productos y transacciones.",
        },
        {
          "Aprovisionamiento por producto":
            "En este resumen, se puede ver el total de mensajes enviados dentro del límite y envíos extras, así como el total de monto generado dentro del límite y envíos extras por cada tipo de producto que posea el cliente.",
        },
        {
          "Resumen de transacciones":
            "Este resumen muestra todas las transacciones que fueron utilizadas para generar la factura. Las transacciones son vinculadas a la factura cuando se realiza el corte.",
        },
        {
          "Generar recibo":
            "Este botón genera y muestra en pantalla el recibo de consumo con el detalle de los montos por mensajes enviados por producto y el detalle de las transacciones que se procesaron para este corte.",
        },
      ],
    },
    supportTasks: {
      path: "/soporte/tareas-soporte",
      components: [
        {
          "Tareas de soporte": `Bienvenido al módulo de 'tareas de soporte', en este apartado es posible llevar un control de las tareas
                              asignadas al departamento de soporte, ordenadas y clasificadas por prioridad y estado.`,
        },

        {
          "Prioridades":
            "Las prioridades de las tareas son: Baja, Media y Alta, dependiendo de su priorirad se mostraran en pantalla con su respectivo simbolo y color.",
        },
        {
          "Estados":
            "Los estados de las tareas son: Pendiente, En proceso y Resuelta, dependiendo de su estado se mostraran en pantalla con su respectivo simbolo y color, es posible cambiar el estado manualmente en el transcurso en que se van desarrollando las tareas.",
        },
      ],
    },
    supportParams: {
      path: "/soporte/parametros",
      components: [
        {
          "Parametros": `En este apartado es posible definir ciertos parámetros técnicos en cuanto a limitantes en el uso de los servicios de la plataforma para los usuarios, ademas 
                       de la configuracíon de recursos internos, entre ellos:`,
        },
        {
          "Límite de carga de contactos":
            "Cantidad máxima de contactos que se pueden cargar en un archivo",
        },
        {
          "Límite de filas de envío SMS":
            "Cantidad máxima de filas que se pueden enviar en un archivo para envío de SMS",
        },
        {
          "Límite de contactos por grupos":
            "Cantidad máxima de contactos permitidos por cada grupo de contactos",
        },
        {
          "Correos internos":
            "Desde esta sección se pueden definir los correos electrónicos tanto para el equipo de soporte como el equipo de ventas",
        },
        {
          "Fake Send":
            "Esta opción permite enviar mensajes de prueba a un número de teléfono especifico para validar el funcionamiento de la plataforma",
        },
      ],
    },
    supportServerLogs: {
      path: "/soporte/registros-servidor",
      components: [
        {
          "Registros de servidor": `En este módulo es posible la visualización del estado de ciertos procesos automatizados que se ejecutan en el servidor, como ser:
                                   'cron jobs', scripts de reportes entre otros.`,
        },
      ],
    },
    log: {
      path: "/bitacora/reporte",
      components: [
        {
          "Bitácora": `Bienvenido al módulo de 'bitácora' en este apartado es posible ver las acciones más relevantes realizadas por los usuarios de todos los subclientes de todos los Propietarios.`,
        },
      ],
    },
  },

  admin: {
    role: "CADM",
    dashboard: {
      path: "/dashboard",
      components: [
        {
          "Dashboard": `Bienvenido al Dashboard. Aquí se muestran graficamente los envíos de 
                          todos los clientes basados en las siguientes metricas:`,
        },
        { "Envíos mensuales": "Total de envíos en el mes por cliente." },
        {
          "Envíos por medio usado (año)":
            "Total de envíos en el mes por producto.",
        },
        {
          "Envíos por tipo (año)": `Envíos por tipo de envío el cual está ligado al producto, por
                                      ejemplo enviar por sms.`,
        },
        {
          "Envíos por subclientes (mensual)":
            "Total de envíos de todos los clientes",
        },
        {
          "Envíos por producto":
            "Total envíos agrupados por el tipo de envío en los productos.",
        },
      ],
    },
    plan: {
      path: "/planes",
      components: [
        {
          "Planes": `Bienvenido al módulo 'Planes' . Aquí puedes crear y visualizar los planes que 
                      posteriormente serán asignados a los clientes`,
        },
        {
          "Crear nuevo plan":
            "Haga click en el botón 'nuevo' para entrar a la vista de creación y poder definir un nuevo plan.",
        },
        {
          "Lista de planes":
            "Todos los planes creados en base dueño y estado.",
        },
        {
          "Ver": `En la columna 'acciones' haga click en el icono "ver" y obtenga información de aprovisionamiento del plan de la fila seleccionada,
                tal como tipo de producto, cantidad entre otros. `,
        },
        {
          "Clientes":
            "En la columna 'acciones' haga click sobre el ícono clientes para ver los subclientes a los que se asigna dicho plan.",
        },
      ],
    },
    createPlan: {
      path: "/planes/agregar",
      components: [
        {
          "Crear plan":
            "En esta sección es posible crear un nuevo plan para asignar posteriormente a un cliente",
        },
        {
          "Aprovisionamiento":
            "Haga click en el boton 'agregar producto' para elegir los parametros del producto que se agregará al plan.",
        },
        {
          "Tipo de consumo": `El tipo 'Consumible' significa pagar por lo que usas  mientras el 'no consumible' implica una tarifa plana, es decir paga una cantidad fija, independientemente del uso.`,
        },
        {
          "Mensaje extra": ` Es posible agregar cierta cantidad de mensajes extra al plan una vez este se cumpla, debe 
                              seleccionar la casilla 'mensajes extra' para asignar un costo unitario por cada mensaje agregado y ademas existe la posibilidad
                              de habilitar una cantidad definida o indefinida de mensajes bajo esta modalidad.`,
        },
      ],
    },
    category: {
      path: "/categorias",
      components: [
        {
          "Categorías": `Bienvenido a la sección 'Categorías', Aquí podrá administrar la gestión de categorías para asignarlas 
                        a los clientes, Cada categoría tendrá un nombre y una descripción asignada.`,
        },
        {
          "Nuevo":
            "Genera un nombre y descripción para una nueva categoría, con esta se puede etiquetar a los clientes",
        },
        {
          "Eliminar y editar":
            "Una vez creada, solo es posible eliminar o editar el nombre y descripción de una categoría.",
        },
      ],
    },
    adminCustomers: {
      path: "/clientes/admin",
      components: [
        {
          "Administrar Clientes": `Bienvenido al módulo 'Clientes', concretamente a la sección de administración. aquí podrá visualizar y gestionar sus clientes. 
                                  Puede agregar nuevos subclientes, deshabilitar y editar información de cada uno de ellos`,
        },
        {
          "Inhabilitar":
            "Haz click en icono de dehabilitar, al inhabilitar un propietario se le quitara a acceso a su administrador y a todos los usuarios de los subclientes que este contenga",
        },
        {
          "Crear distinción de costos":
            "Esta acción está disponible para subclientes que no posean distinción de costos (Cuenta EMG).",
        },
      ],
    },
    createNewCustomer: {
      path: "/clientes/admin/agregar",
      components: [
        {
          "Crear nuevo cliente": `En esta sección se establecen los datos del cliente y además podrá solicitar distinción de costos, cuando esté habilitado, se realizará
                                   la solicitud al equipo de soporte para que puedan crear las credenciales de EMG y asignarlas posteriormente al subcliente para que pase a un estado de “aprobado”.`,
        },
        {
          "Datos a ingresar":
            "Se le solicitará un plan con el aprovisionamiento de productos a asignar, un día de corte que se realizará el reinicio de conteo de envíos y creación automática de recibos, siendo esto solamente día entre 1-28",
        },
      ],
    },
    customerConsuption: {
      path: "/clientes/consumo",
      components: [
        {
          "Resumen de consumo": `En esta sección se puede visualizar información de utilidad en cuanto al control
                                  del consumo de los clientes en base a su plan asignado, destacan:`,
        },
        {
          "Propietario:": "Cuenta propietaria del subcliente",
        },
        {
          "Estado": "Activo/inactivo, determina la validez actual del plan para el subcliente. ",
        },
        {
          "Enviados dentro/fuera":
            "Cantidad de mensajes enviados en base al plan inicial o por fuera de este como un 'extra'",
        },
        {
          "Filtrar:":
            "Es posible filtrar por propietario o realizar una busqueda por palabra clave.",
        },
        {
          "Descargar":
            "Haga click en el boton 'descargar' para bajar un archivo CSV con todos los registros de consumo del propietario seleccionado.",
        },
      ],
    },
    securityBlackList: {
      path: "/seguridad/lista-negra",
      components: [
        {
          "Lista negra":
            "Bienvenido a la sección de lista negra, en este módulo es posible visualizar los números de teléfono enviados a la 'blacklist' el cual no podrá recibir ni enviar tráfico",
        },
        {
          "": "aquí se muestran los números de teléfono bloqueados por sus clientes",
        },
      ],
    },
    securityBlackOut: {
      path: "/seguridad/black-out",
      components: [
        {
          "Fuera de linea": `En esta parte del sistema es posible crear horarios en los que no se podrá
                            enviar ni recibir tráfico durante las horas y fechas establecidas por sus clientes.`,
        },
      ],
    },
    adminUsers: {
      path: "/admin/usuarios",
      components: [
        {
          "Administrar usuarios": `En este módulo es posible visualizar, crear y asignar usuarios a sus clientes, el detalle se
                                  muestra en la lista en pantalla.`,
        },
        {
          "Editar":
            "Haz click en el ícono de edición y será posible editar la información de un usuario existente.",
        },
        {
          "Deshabilitar":
            "Es posible eliminar cualquier usuario desde este botón en la columna 'acciones'",
        },
        {
          "Copiar API key":
            "Esta acción es posible para los clientes remitentes al hacer click sobre el boton copiar bajo la columna 'aaciones'",
        },
      ],
    },
    adminUsersNew: {
      path: "/admin/usuarios/agregar",
      components: [
        {
          "Agregar usuario":
            "En esta sección es posible crear un nuevo usuario y asignarlo a un cliente para que sea quien acceda al sistema y realice las tareas de envío.",
        },
        { "Cliente": "Asignar un cliente al usuario" },
        {
          "Control de acceso y envíos":
            "En la parte derecha de la pantalla se muestran las casillas para configurar los permisos que tendrá el usuario, tanto para tipos de envío y control de acceso a los módulos del sistema",
        },
        {
          "*Nota":
            "Debe existir previamente el 'cliente' antes de asignarlo al 'usuario' que se esta creando y que será quien accede al sistema",
        },
      ],
    },
    adminAgenda: {
      path: "/admin/agenda-cambios",
      components: [
        {
          "Agenda de cambios": `Bienvenido al componente 'Agenda de cambios', aquí podrá gestionar los cambios de planes pendientes de aplicar en las
                              fechas de corte, permitiendo verlo desde una perspectiva de calendario`,
        },
      ],
    },
    adminSenders: {
      path: "/admin/remitentes",
      components: [
        {
          "Gestión de remitentes": `Bienvenido al componente 'Gestión de remitentes', aquí podrá gestionar los remitentes de todos sus clientes.`,
        },
      ],
    },
    adminConfiguration: {
      path: "/admin/configuracion",
      components: [
        {
          "Configuración": `Este módulo te permite configurar los temas y estilos de la aplicación para que se adapten a la identidad visual de tu empresa. Para ello, 
                          puedes cambiar los colores, el logotipo y otros elementos de la interfaz. `,
        },
        {
          "General":
            "En la sección general se puede elegir el cliente a quien se aplicarán los cambios en la aplicación.",
        },
        {
          "Logo": "En la sección de logo, haga click en seleccionar para subir la imagen de su corporación, solo admite el formato PNG.",
        },
        {
          "Imagen de carga":
            "En esta sección se puede definir la imagen que se mostrará en pantalla de carga mientras navega por la app",
        },
        {
          "Paleta de colores":
            "En la parte inferior de los componentes anteriores encontrará la paleta de colores personalizable para identificarse con los colores de su marca.",
        },
      ],
    },
    phonebook: {
      path: "/directorio-telefonico",
      components: [
        {
          "Directorio telefónico": `Bienvenido al módulo de 'directorio telefónico', aquí se realiza la visualización y gestión
                                  de grupos de contactos creados por sus clientes para realizar envíos`,
        },
      ],
    },
    reportsSentSms: {
      path: "/reportes/sms-enviados",
      components: [
        {
          "Mensajes enviados": `Bienvenido al módulo de mensajes enviados, esta vista permite visualizar un listado de los envíos realizados, 
                              este módulo también contiene filtros de fecha los cuales sirven para acotar los envíos por un rango de fechas`,
        },
        {
          "Acciones":
            "En este apartado haga click sobre el icono de 'ver' para obtener el reporte de mensajes enviados por el cliente",
        },
      ],
    },
    reportsProcessedFiles: {
      path: "/reportes/archivos-procesados",
      components: [
        {
          "Archivos procesados": `Bienvenido al módulo de 'archivos procesados' Esta vista te permite ver un listado de todos los archivos que han sido
                                procesados por la aplicación. Para acotar los resultados, puedes utilizar los filtros de fecha y cliente.`,
        },
        {
          "Acciones":
            "Este apartado muestra las acciones que puede realizar sobre estos reportes.",
        },
        {
          "Ver": "Haz click en los íconos ver para obtener información mas detallada sobre el archivo procesado.",
        },
        {
          "Descargar":
            "Haz click en el ícono descargar para obtener el archivo procesado en formato CSV.",
        },
      ],
    },
    reportsByRecipient: {
      path: "/reportes/destino",
      components: [
        {
          "Reporte por destinatario": `Bienvenido al módulo de 'reporte por destinatario' Esta vista te permite ver un listado de todos los envíos realizados
                                    tanto por destinatario como por fecha.`,
        },
        {
          "¿como buscar?":
            "En la columna destinatario se debe introducir el número de teléfono con el prefijo de este para obtener el reporte de envíos  por destinatario de todos los subclientes de todos los Propietarios.",
        },
      ],
    },
    reportsProgrammedFiles: {
      path: "/reportes/archivos-programados",
      components: [
        {
          "Archivos Programados": `Bienvenido al módulo de 'archivos programados' Esta vista te permite la visualización de los envíos programados de todos tus clientes.
                                 para acotar los resultados, puedes utilizar los filtros de fecha.`,
        },
      ],
    },

    reportsTransactions: {
      path: "/reportes/transacciones",
      components: [
        {
          "Transacciones": `Bienvenido al módulo de 'transacciones', en este apartado es posible la visualización de las transacciones de
                          envíos realizadas de todos sus clientes.`,
        },
        {
          "Parametros de busqueda":
            "Los resultados se filtran por fecha de inicio y final.",
        },
      ],
    },
    billingReport: {
      path: "/facturacion/reporte",
      components: [
        {
          "Detalle de facturación":
            "Bienvenido al apartado de facturación, aquí es posible la visualización de las facturas generadas en los ciclos de corte por cada cliente.",
        },
        {
          "Acciones":
            "Haga click en el botón 'ver' para ver el detalle de la factura seleccionada",
        },
      ],
    },
    billingReportDetails: {
      path: "/facturacion/reporte/detalles",
      components: [
        {
          "Detalle de facturación":
            "Bienvenido al apartado de detalle de facturación, aquí es posible la generación de recibo, visualizar aprovisionamiento de productos y transacciones.",
        },
        {
          "Aprovisionamiento por producto":
            "En este resumen, se puede ver el total de mensajes enviados dentro del límite y envíos extras, así como el total de monto generado dentro del límite y envíos extras por cada tipo de producto que posea el cliente.",
        },
        {
          "Resumen de transacciones":
            "Este resumen muestra todas las transacciones que fueron utilizadas para generar la factura. Las transacciones son vinculadas a la factura cuando se realiza el corte.",
        },
        {
          "Generar recibo":
            "Este botón genera y muestra en pantalla el recibo de consumo con el detalle de los montos por mensajes enviados por producto y el detalle de las transacciones que se procesaron para este corte.",
        },
      ],
    },
    log: {
      path: "/bitacora/reporte",
      components: [
        {
          Bitacora: `Bienvenido al módulo de 'bitácora' en este apartado es posible ver las acciones más relevantes realizadas por todos sus clientes.`,
        },
      ],
    },
  },

  sender: {
    role: "CUSR",
    dashboard: {
      path: "/dashboard",
      components: [
        {
          "Dashboard": `Bienvenido al Dashboard. Este es tu centro de operaciones donde 
            puedes obtener una vista rápida de la actividad reciente y las métricas clave de envíos. 
            Aprovecha las herramientas de análisis para tomar decisiones informadas:`,
        },
        {
          "envíos semanales": "Total de mensajes enviados en la última semana.",
        },
        { "Envíos mensuales": "Total de mensajes enviados en el mes." },
        {
          "Envíos por medio usado (año)":
            "Total de envíos en el mes por producto.",
        },
        {
          "Envíos por tipo (año)": `Envíos por tipo de envío el cual está ligado al producto, por
                                      ejemplo enviar por sms.`,
        },
        {
          "Envíos por producto":
            "Total envíos agrupados por el tipo de envío en los productos.",
        },
      ],
    },
    securityBlackList: {
      path: "/seguridad/lista-negra",
      components: [
        {
          "Lista negra":
            "Bienvenido a la sección de lista negra, en este módulo es posible enviar números de teléfono a la 'blacklist' los cuales no podrán enviar ni recibir tráfico",
        },
        {
          "Nuevo":
            "Haga click en el botón nuevo para agregar uno o varios números de teléfono a la lista negra",
        },
        {
          "Eliminar":
            "Haga click en el icono de la papelera para eliminar un número de teléfono de la lista negra y que este pueda enviar y recibir tráfico",
        },
        {
          "Editar":
            "Haga click en el icono de edición para editar la información un número de teléfono en la blacklist",
        },
      ],
    },
    securityBlackListAdd: {
      path: "/seguridad/lista-negra/agregar",
      components: [
        {
          "Agregar a lista negra":
            "En esta sección es posible agregar uno o varios números de teléfono a la lista negra",
        },
        {
          "Agregar un solo numero":
            "Mantenga la casilla 'cargar lista de números' desmarcada y agregue un solo número de teléfono",
        },
        {
          "Agregar varios numeros:":
            "Mantenga la casilla 'cargar lista de números' marcada y verá un campo para subir un archivo CSV con los números de teléfono a agregar",
        },
        {
          "Descargar Plantilla":
            "Al activar la casilla descrita antes, verá a la derecha del campo de carga un botón con simbolo de flecha hacia abajo, haga click sobre él para descargar la plantilla CSV que indica como subir el archivo con el total de números a bloquear",
        },
      ],
    },
    securityBlackOut: {
      path: "/seguridad/black-out",
      components: [
        {
          "Fuera de linea": `Bienvenido a la sección 'Fuera de línea' Aquí es posible establecer rangos de horarios donde no se podrá realizar envíos. Es posible agregar
                             múltiples rangos donde se hará la validación en todos ellos al momento de realizar envíos.`,
        },
        {
          "Nuevo":
            "Haga click en el botón 'nuevo' para abrir una ventana donde podrá establecer un nuevo rango de horario",
        },
      ],
    },
    phonebook: {
      path: "/directorio-telefonico",
      components: [
        {
          "Directorio telefónico": `Bienvenido al módulo de 'directorio telefónico', aquí es posible la creación y gestión
                                  de grupos de contacto con un límite por defecto de 5,000 por cada grupo para realizar envíos`,
        },
        {
          "Nuevo":
            "Haga click en el botón 'nuevo' para abrir una ventana donde podrá crear un nuevo grupo de contactos",
        },
      ],
    },
    phonebookAdd: {
      path: "/directorio-telefonico/crear",
      components: [
        {
          "Crear grupo de contactos":
            "En esta sección es posible crear un nuevo grupo de contactos para manejar los envíos",
        },
        {
          "Nombre":
            "Este es el nombre que asignará al grupo de contactos, al hacerlo desplegará la sección de agregar contactos, tendra la opción de hacerlo individualmente o por medio de la carga de un archivo CSV con los contactos",
        },
        {
          "Plantilla":
            "Al seleccionar la opción de 'cargar archivo' verá un icono de flecha hacia abajo, haga click sobre él y obtendrá un archivo CSV como guía para el archivo que deberá subir con sus contactos.",
        },
      ],
    },
    whatsappFastDelivery: {
      path: "/whatsapp/rapido",
      components: [
        {
          "Whatsapp": `Bienvenido al módulo de whatsapp, aquí es posible la visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    whatsappFileAttachment: {
      path: "/whatsapp/archivo",
      components: [
        {
          "Whatsapp": `Visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    whatsappChat: {
      path: "/whatsapp/chat",
      components: [
        {
          "Whatsapp": `Visualización y gestión de mensajes de WhatsApp, tanto envío simple, envío con archivo y control de chat. Este módulo sigue en construcción`,
        },
      ],
    },
    smsFastDelivery: {
      path: "/sms/rapido",
      components: [
        {
          "SMS": "Bienvenido al módulo de SMS, aquí es posible la visualización y gestión de mensajes de texto, tanto envío simple como envío con archivo",
        },
        {
          "Envío rápido":
            "Esta vista contiene un formulario que le permite el envío de un mensaje a la vez,",
        },
        {
          "Envío con directorio": "Haga click en el ícono de la esquina superior derecha para realizar un envío de sms desde un directorio telefónico previamente creado."
        }
      ],
    },
    smsFileAttachment: {
      path: "/sms/archivo",
      components: [
        {
          "SMS": "Bienvenido al módulo de SMS, aquí es posible la visualización y gestión de mensajes de texto, tanto envío simple como envío con archivo",
        },
        {
          "Envío con archivo":
            "Esta vista contiene un formulario que le permite el envío masivo por medio de un archivo CSV con los números de teléfono y el mensaje a enviar.",
        },
      ],
    },
    reportsSentSms: {
      path: "/reportes/sms-enviados",
      components: [
        {
          "Mensajes enviados": `Bienvenido al módulo de mensajes enviados, esta vista permite visualizar un listado de los envíos realizados, 
                              este módulo también contiene filtros de fecha los cuales sirven para acotar los envíos por un rango de fechas`,
        },
        {
          "Descargar":
            "Haga click en 'descargar' para obtener un archivo CSV con el reporte de todos los mensajes en el rango actual",
        },
      ],
    },
    reportsProcessedFiles: {
      path: "/reportes/archivos-procesados",
      components: [
        {
          "Archivos procesados": `Bienvenido al módulo de 'archivos procesados' Esta vista te permite ver un listado de todos los archivos que han sido
                                procesados por la aplicación. Para acotar los resultados, puedes utilizar los filtros de fecha y cliente.`,
        },
        {
          "Acciones":
            "Este apartado muestra las acciones que puede realizar sobre estos reportes.",
        },
        {
          "Ver": "Haz click en los íconos ver para obtener información mas detallada sobre el archivo procesado.",
        },
        {
          "Descargar":
            "Haz click en el ícono descargar para obtener el archivo procesado en formato CSV.",
        },
      ],
    },
    reportsByRecipient: {
      path: "/reportes/destino",
      components: [
        {
          "Reporte por destinatario": `Bienvenido al módulo de 'reporte por destinatario' Esta vista te permite ver un listado de todos los envíos realizados
                                    tanto por destinatario como por fecha.`,
        },
        {
          "¿como buscar?":
            "En la columna destinatario se debe introducir el número de teléfono con el prefijo de este para obtener el reporte de envíos  por destinatario de todos los subclientes de todos los Propietarios.",
        },
      ],
    },
    reportsProgrammedFiles: {
      path: "/reportes/archivos-programados",
      components: [
        {
          "Archivos Programados": `Bienvenido al módulo de 'archivos programados' Esta vista te permite la visualización de todos los envíos programados realizados.
                                 para acotar los resultados, puedes utilizar los filtros de fecha.`,
        },
      ],
    },

    reportsTransactions: {
      path: "/reportes/transacciones",
      components: [
        {
          "Transacciones": `Bienvenido al módulo de 'transacciones', en este apartado es posible la visualización de las transacciones de
                          envíos realizadas.`,
        },
        {
          "Parametros de búsqueda":
            "Los resultados se filtran por fecha de inicio y final",
        },
      ],
    },
    log: {
      path: "/bitacora/reporte",
      components: [
        {
          Bitacora: `Bienvenido al módulo de 'bitácora' en este apartado es posible ver las acciones más relevantes realizadas por todos los usuarios.`,
        },
      ],
    },
    consumption: {
      path: "/resumen/plan-consumido",
      components: [
        {
          "Resumen de consumo actual":
            "Bienvenido al apartado de consumo actual, en este espacio es posible visualizar un resumen de consumo actual en base a las transacciones realizadas previas al próximo corte, este resumen contiene",
        },
        {
          "Plan actual":
            "Resumen del plan actual asignado en base a cantidad y tipo de producto",
        },
        {
          "Resumen del cliclo":
            "Muestra un resumen de la cantidad de mensajes enviados",
        },
        {
          "Aprovisionamiento":
            "Muestra la cantidad de mensajes asignados y consumidos e informacíon sobre el tipo de plan asignado.",
        },
      ],
    },
  },
};
